// Translations
import landing from '../views/landing/translations/ua'

// Translation: Reset (Ukrainian)
export default Object.freeze({
	name: '',
	views: { landing }
})
